import {
  CANCEL_INGESTION_REQUEST,
  CANCEL_INGESTION_SUCCESS,
  CANCEL_INGESTION_FAILURE,
  CANCEL_INGESTION_RESET,
} from '../../../Constants/actionTypes';

import { cancelIngestionApi } from '../../../Constants/apiService';

export const cancelIngestionRequest = () => ({ type: CANCEL_INGESTION_REQUEST });
export const cancelIngestionSuccess = (data) => ({ type: CANCEL_INGESTION_SUCCESS, payload: data });
export const cancelIngestionFailure = (error) => ({ type: CANCEL_INGESTION_FAILURE, payload: error });
export const cancelIngestionReset   = () => ({ type: CANCEL_INGESTION_RESET });

/**
 * taskId: backend ingestion task id (from polling status)
 */
export const cancelIngestion = (taskId) => {
  return async (dispatch, getState) => {
    dispatch(cancelIngestionRequest());
    const accessToken = getState().auth.accessToken;

    try {
      const data = await cancelIngestionApi(taskId, accessToken);
      dispatch(cancelIngestionSuccess(data));
      return data;
    } catch (err) {
      const message = err.message || 'Failed to cancel ingestion';
      dispatch(cancelIngestionFailure(message));
      throw err;
    }
  };
};
